import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-edit-icon',
    templateUrl: './edit-icon.component.html',
    styleUrls: ['./edit-icon.component.scss']
})
export class EditIconComponent extends AbstractIcon {
    constructor() {
        super();
        this.height = 24;
        this.width = 24;
    }

}
